import { defineMessages } from 'react-intl';

export default defineMessages({
  sectionTitle: {
    defaultMessage: 'Configure Return Shipment',
    description: 'Title for the section to configure return shipment details',
    id: 'b/hfPL',
  },
  sectionAriaLabel: {
    defaultMessage: 'Configure Return Shipment expander section',
    description: 'Aria label for the expandable configure return shipment section',
    id: 'Ma0h+/',
  },
  emailOption: {
    description: 'returnLabelDispatcher.emailLabelOption',
    defaultMessage: 'Email label',
    id: 'FWDTS6',
  },
  downloadOption: {
    description: 'returnLabelDispatcher.downloadLabelOption',
    defaultMessage: 'Download label now',
    id: '2K09qN',
  },
  emailAddressListLabel: {
    description: 'returnLabelDispatcher.emailAddressListLabel',
    defaultMessage: 'Email to',
    id: 'LouTfi',
  },
  emailAddressListInstructions: {
    description: 'returnLabelDispatcher.emailAddressListInstructions',
    defaultMessage: 'Use commas for multiple addresses',
    id: 'iGI+Lw',
  },
  rmaNumberLabel: {
    defaultMessage: 'RMA #',
    description: 'rmaNumberInput.rmaNumber',
    id: 'fKLI3n',
  },
  autoAssignRMANumberLabel: {
    defaultMessage: 'Auto Assign RMA #',
    description: 'rmaNumberInput.autoAssign',
    id: '6zcb33',
  },
  invalidEmail: {
    defaultMessage: 'Invalid email address',
    description: 'Validation error message showing that the given email address is invalid',
    id: '91NixD',
  },
});
